// extracted by mini-css-extract-plugin
export default {"container":"Page404_container__sKNzs","content":"Page404_content__pfeqw","piscar":"Page404_piscar__TGj8n"};